module.exports = __webpack_public_path__ + "static/media/certik_report.f4476c42.pdf";